import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';

interface SubmissionPopupProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  isLarry?: boolean;
  isLeo?: boolean;
  redirectUrl?: string;
}

export default function SubmissionPopup({ isOpen, onClose, message, isLarry, isLeo, redirectUrl }: SubmissionPopupProps) {
  React.useEffect(() => {
    if (isOpen && redirectUrl) {
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, redirectUrl]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-black/90 rounded-2xl p-8 max-w-md w-full border border-gray-800"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex justify-end">
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="text-center">
              <CheckCircle className="w-16 h-16 text-golden mx-auto mb-6" />
              <h2 className="text-2xl font-bold mb-4">
                {isLarry ? "Thank you for your time Larry!" : 
                 isLeo ? "Thank you for your time Leo!" : 
                 "Thanks for contacting us!"}
              </h2>
              <p className="text-lg text-gray-300">
                {isLarry ? "Pascoal will be in touch shortly!" : 
                 isLeo ? "You will be redirected to schedule your meeting shortly." : 
                 message || "We'll be in touch shortly!"}
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}